<template>
	<div class="login-center-wrap">
		<!-- <div id="loginCenterLeft" class="vhalf fleft flex-center">
			<ul class="login-edc-list no-drag">
				<li></li>
				<li></li>
				<li></li>
				<li></li>
				<li></li>
			</ul>
		</div> -->
		<div id="loginCenterRight">
			<form class="login-form" @submit.prevent="doLogin">
				<img class="login-head" src="@/assets/images/login/login_head.png" alt=""/>
				<!-- <label for="userId" class="login-form-label flex-center">
					<img src="@/assets/images/login/id_icon_login.png" alt="" />
					User ID
				</label> -->
				<span class="login-name bold"></span>
				<input
					type="text"
					id="userId"
					v-model="userId"
					ref="userId"
					class="input-login-style sha-focus-666 bmargin-15"
					placeholder="ID"
					autocomplete="off"
					v-validate="'required|min:4'"
					data-vv-name="UserID"
					style="margin-top: 4.2vh"
				/>

				<!-- <label for="password" class="login-form-label flex-center">
					<img src="@/assets/images/login/pw_icon_login.png" alt="" />
					PASSWORD
				</label> -->
				<input
					type="password"
					id="password"
					v-model="password"
					ref="password"
					class="input-login-style sha-focus-666"
					placeholder="Password"
					autocomplete="off"
					v-validate="'required|min:6'"
					data-vv-name="Password"
					@keydown.enter="doLogin"
					style="margin-top: 1.68vh;"
				/>

				<button type="button" class="login-button" @click="doLogin">
					Login
				</button>

				<!-- <div class="login-form-bottom">
					<button type="button" class="button-line-white fleft" @click.prevent="signUp()">
						Sign up
					</button>
					<button type="button" class="button-line-white fright" @click.prevent="findUser()">
						Find Account
					</button>
				</div> -->

				
				<!-- <div class="login-sub">
					<button type="button" @click.prevent="findUser(1)">Find ID</button>
					<div>|</div>
					<button type="button" @click.prevent="findUser(2)">Find Password</button>
					<div>|</div>
					<button type="button" @click.prevent="signUp()">Signup</button>
				</div> -->

				<!-- <div class="login-call">
					<span>Customer Service</span>
					<span style="font-weight: bold; color:#004098;">043-835-1533</span>
				</div> -->

				<div class="login-sponser">
					<!-- <img style="width: 5.37vmax;" src="@/assets/images/login/agency_img_1.png" alt=""/>
					<img style="width: 4.54vmax;" src="@/assets/images/login/agency_img_3.png" alt=""/>
					<img style="width: 5.94vmax;" src="@/assets/images/login/agency_img_4.png" alt=""/> -->
				</div>
			</form>
		</div>
	</div>
</template>

<script>
import Vue from "vue";
import VeeValidator from "vee-validate";
Vue.use(VeeValidator);

export default {
	name: "Login",
	created() {
		this.logger.debug(this, ".created()");
		console.log(this.userInfo.userId);
		if (!this.utils.isEmpty(this.userInfo.userId)) {
			this.$router.push(this.config.contextRoot + "/notice/list");
		}
	},
	mounted() {
		this.logger.debug(this, ".mounted()");
	},
	data() {
		return {
			userId: "",
			password: "",
			loginResult: false,
			findId: "N",
			findPass: "N"
		};
	},
	methods: {
		doLogin() {
			this.logger.debug(this, "doLogin");

			this.$validator
				.validateAll()
				.then((result) => {
					this.logger.debug(this, "valid:" + result);
					if (!result) {
						return;
					}

					this.$Auth.login(
						this.userId,
						this.password,
						function(loginResult) {
							if (loginResult) {
								this.$router.replace(
									this.$route.query.redirect || this.config.contextRoot + "/notice/list/"
								);
							} else {
								this.logger.debug(this, "loginResult:" + loginResult);
							}
						}.bind(this)
					);
				})
				.catch(() => {
					this.logger.debug(this, "-->" + this.errors.all());
					this.$alert(this.errors.all());
					return false;
				});
		},
		signUp() {
			this.logger.debug(this, ".signUp()");
			this.$router.push(this.config.contextRoot + "/login/sign/agree");
		},
		findUser(code) {
			this.logger.debug(this, ".findUser()");
			if(code == 1){
				this.$router.push(this.config.contextRoot + "/login/find/account/id");
			}
			else{
				this.$router.push(this.config.contextRoot + "/login/find/account/password");
			}
		},
	},
};
</script>
